import { Conduit } from '@aligned-solutions/conduit';
import { authentication } from '../interceptors/request';

const conduit = new Conduit(
  `${process.env.TWENTY_API_URL}products/ferry/`,
  [],
  [authentication],
  [],
  false,
  30000,
  true,
);

export default {

  /**
   * Retrieve a list of suppliers.
   *
   * @returns {AxiosPromise}
   */
  getSuppliers() {
    return conduit.get('suppliers');
  },

  getDomains() {
    return conduit.get('domains');
  },

  /**
   * Retrieve a list of car types.
   *
   * @param supplier
   * @param domainId
   * @returns {AxiosPromise}
   */
  getCarTypes(supplier, domainId) {
    return conduit.get(`car-types/supplier/${supplier}/domain/${domainId}`);
  },

  /**
   * Save a car type.
   *
   * @param supplierId
   * @param domainId
   * @param payload
   * @returns {AxiosPromise}
   */
  saveCarType(supplierId, domainId, payload) {
    return conduit.put(`car-types/supplier/${supplierId}/domain/${domainId}`, payload);
  },

  /**
   * Save a car type.
   *
   * @param supplierId
   * @param domainId
   * @param payload
   * @returns {AxiosPromise}
   */
  addCarType(supplierId, domainId, payload) {
    return conduit.post(`car-types/supplier/${supplierId}/domain/${domainId}`, payload);
  },

  /**
   * Retrieve a list of routes
   *
   * @param supplier
   * @param domainId
   * @returns {AxiosPromise}
   */
  getRoutes(supplier, domainId) {
    return conduit.get(`routes/supplier/${supplier}/domain/${domainId}`);
  },

  /**
   * Save a route.
   *
   * @param payload
   * @returns {*}
   */
  saveRoute(payload) {
    return conduit.put(`routes/route/${payload.route.id}/domain/${payload.domainId}`, payload.route);
  },

  /**
   * @param route
   * @param domainId
   * @returns AxiosPromise
   */
  getCheckInInformationForRoute(route, domainId) {
    return conduit.get(`routes/route/${route.id}/domain/${domainId}/check-in-information`);
  },

  /**
   * @param routeId
   * @returns {AxiosPromise}
   */
  getRouteTextTags(routeId) {
    return conduit.get(`routes/route/${routeId}/texts/tags`);
  },

  /**
   * @param routeId
   * @param domainId
   * @returns {AxiosPromise}
   */
  getRouteTexts(routeId, domainId) {
    return conduit.get(`routes/route/${routeId}/domain/${domainId}/texts`);
  },

  /**
   * @param routeId
   * @param text
   * @param domainId
   * @returns {AxiosPromise}
   */
  createRouteText(routeId, text, domainId) {
    return conduit.post(`routes/route/${routeId}/domain/${domainId}/texts`, text);
  },

  /**
   * @param routeId
   * @param domainId
   * @param textId
   * @param text
   * @returns {AxiosPromise}
   */
  updateRouteText(routeId, domainId, textId, text) {
    return conduit.put(`routes/route/${routeId}/domain/${domainId}/texts/${textId}`, text);
  },

  /**
   * @param routeId
   * @param domainId
   * @param textId
   * @returns {AxiosPromise}
   */
  deleteRouteText(routeId, domainId, textId) {
    return conduit.delete(`routes/route/${routeId}/domain/${domainId}/texts/${textId}`);
  },


  /**
   * @param route
   * @param domainId
   * @param info
   * @returns {*}
   */
  saveCheckInInformationForRoute(route, domainId, info) {
    return conduit.put(`routes/route/${route.id}/domain/${domainId}/check-in-information`, info);
  },

  /**
   * Retrieve route areas.
   *
   * @param route
   * @returns {*}
   */
  getRouteAreas(route) {
    if (!route.areaIds.length) {
      return Promise.resolve({ data: [] });
    }
    return conduit.post('twenty/areas/by-area-ids', {
      areaIds: route.areaIds,
    });
  },

  /**
   * @returns AxiosPromise
   */
  getNonDynamicTransports() {
    return conduit.get('routes/non-dynamic-transports');
  },

  /**
   * @returns {AxiosPromise}
   * @param supplierId
   * @param domainId
   */
  getPersonCategoriesBySupplier(supplierId, domainId) {
    return conduit.get(`person-categories/supplier/${supplierId}/domain/${domainId}`);
  },

  /**
   * @param supplierId
   * @param domainId
   * @param payload
   * @returns {AxiosPromise}
   */
  savePersonCategoryBySupplier(supplierId, domainId, payload) {
    return conduit.put(`person-categories/supplier/${supplierId}/domain/${domainId}/update`, payload);
  },

  /**
   * @param supplierId
   * @param domainId
   * @param payload
   * @returns {AxiosPromise}
   */
  addPersonCategoryBySupplier(supplierId, domainId, payload) {
    return conduit.post(`person-categories/supplier/${supplierId}/domain/${domainId}/add`, payload);
  },

  /**
   * @param routeId
   * @param domainId
   * @param cabin
   * @returns {AxiosPromise}
   */
  updateCabin(routeId, domainId, cabin) {
    return conduit.put(`cabins/route/${routeId}/domain/${domainId}/update`, cabin);
  },

  /**
   * @param routeId
   * @param domainId
   * @param payload
   * @returns {AxiosPromise}
   */
  addCabinByRoute(routeId, domainId, payload) {
    return conduit.post(`cabins/route/${routeId}/domain/${domainId}/add`, payload);
  },

  /**
   * @param routeId
   * @param domainId
   * @returns {AxiosPromise}
   */
  getCabinsByRoute(routeId, domainId) {
    return conduit.get(`cabins/route/${routeId}/domain/${domainId}`);
  },

  /**
   * @param seasonDepartureId
   * @param type
   */
  getCabinsPrices(seasonDepartureId, type) {
    return conduit.get(`seasons/prices/${seasonDepartureId}/type/${type}`);
  },

  /**
   * @returns {AxiosPromise}
   * @param routeId
   * @param domainId
   * @param payload
   */
  updateExtra(routeId, domainId, payload) {
    return conduit.put(`extras/route/${routeId}/domain/${domainId}/update`, payload);
  },

  /**
   * @param routeId
   * @param domainId
   * @param payload
   * @returns {AxiosPromise}
   */
  addExtraByRoute(routeId, domainId, payload) {
    return conduit.post(`extras/route/${routeId}/domain/${domainId}/add`, payload);
  },

  /**
   * @param routeId
   * @param domainId
   * @returns {AxiosPromise}
   */
  getExtrasByRoute(routeId, domainId) {
    return conduit.get(`extras/route/${routeId}/domain/${domainId}`);
  },

  /**
   * @param seasonDepartureId
   */
  getDepartureExtrasPrices(seasonDepartureId) {
    return conduit.get(`seasons/prices/${seasonDepartureId}/type/extra`);
  },

  /**
   * @param routeId
   * @returns {AxiosPromise}
   */
  getFerrySeasonsByRoute(routeId) {
    return conduit.get(`fjordline/seasons/routes/${routeId}`);
  },

  /**
   * @param seasonId
   * @param domainId
   * @returns {AxiosPromise}
   */
  getFerrySeasonPrices(seasonId, domainId) {
    return conduit.get(`fjordline/seasons/${seasonId}/domain/${domainId}/prices`);
  },

  /**
   * @param seasonId
   * @param domainId
   * @oaram payload
   * @returns {AxiosPromise}
   */
  saveFerrySeasonPrices(seasonId, domainId, payload) {
    return conduit.post(`fjordline/seasons/${seasonId}/domain/${domainId}/prices/save`, payload);
  },

  /**
   * @param season
   * @returns {AxiosPromise}
   */
  updateFerrySeason(season) {
    return conduit.put(`fjordline/seasons/${season.id}/update`, { season });
  },

  /**
   * @param season
   * @returns {AxiosPromise}
   */
  addFjordlineSeason(season) {
    return conduit.post('fjordline/seasons/add', { season });
  },

  /**
   * @param routeId
   * @returns {AxiosPromise}
   */
  getSeasonsByRoute(routeId) {
    return conduit.get(`seasons/route/${routeId}`);
  },

  /**
   * @param season
   * @returns {AxiosPromise}
   */
  addSeason(season) {
    return conduit.post('seasons/add', { season });
  },

  /**
   * @param season
   * @returns {AxiosPromise}
   */
  updateSeason(season) {
    return conduit.put(`seasons/${season.id}/update`, { season });
  },

  /**
   * @param seasonId
   * @returns {AxiosPromise}
   */
  getSeasonDepartures(seasonId) {
    return conduit.get(`seasons/prices/season/${seasonId}`);
  },

  /**
   * @param seasonDepartureId
   * @param direction
   * @returns {AxiosPromise}
   */
  getDepartureDays(seasonDepartureId, direction) {
    return conduit.get(`seasons/prices/${seasonDepartureId}/direction/${direction}`);
  },

  addDepartureDay(seasonDepartureId, direction, body) {
    return conduit.post(`seasons/prices/${seasonDepartureId}/direction/${direction}`, body);
  },

  deleteDepartureDay(seasonDepartureId, direction, body) {
    return conduit.delete(`seasons/prices/${seasonDepartureId}/direction/${direction}`, body);
  },

  /**
   * @param seasonPrice
   * @returns {AxiosPromise}
   */
  addSeasonDeparture(seasonPrice) {
    return conduit.post('seasons/prices/add', { seasonPrice });
  },

  /**
   * @param seasonDeparture
   * @returns {AxiosPromise}
   */
  updateSeasonDeparture(seasonPrice) {
    return conduit.put(`seasons/prices/${seasonPrice.id}/update`, { seasonPrice });
  },

  /**
   * @param seasonDepartureId
   * @returns {AxiosPromise}
   */
  deleteSeasonDeparture(seasonDepartureId) {
    return conduit.delete(`seasons/prices/${seasonDepartureId}/delete`);
  },

  /**
   * @param seasonDepartureId
   * @param body
   * @returns {AxiosPromise}
   */
  updateDeparturePriceCabin(seasonDepartureId, body) {
    return conduit.post(`seasons/prices/${seasonDepartureId}/type/cabin`, { prices: body });
  },

  /**
   * @param seasonDepartureId
   * @returns {AxiosPromise}
   */
  deleteDeparturePriceCabin(seasonDepartureId, body) {
    return conduit.delete(`seasons/prices/${seasonDepartureId}/type/cabin`, { ids: body });
  },

  /**
   * @param seasonDepartureId
   * @param body
   * @returns {AxiosPromise}
   */
  updateDeparturePriceExtra(seasonDepartureId, body) {
    return conduit.post(`seasons/prices/${seasonDepartureId}/type/extra`, { prices: body });
  },

  /**
   * @param seasonDepartureId
   * @returns {AxiosPromise}
   */
  deleteDeparturePriceExtra(seasonDepartureId, body) {
    return conduit.delete(`seasons/prices/${seasonDepartureId}/type/extra`, { ids: body });
  },

  /**
   * @param priceDay
   * @returns {AxiosPromise}
   */
  createSeasonPriceDay(priceDay) {
    return conduit.post('seasons/prices/days/add', { priceDay });
  },

  /**
   * @param priceDay
   * @returns {AxiosPromise}
   */
  updateSeasonPriceDay(priceDay) {
    return conduit.put(`seasons/prices/days/${priceDay.id}/update`, { priceDay });
  },

  /**
   * @param priceDayId
   * @returns {AxiosPromise}
   */
  deleteSeasonPriceDay(priceDayId) {
    return conduit.delete(`seasons/prices/days/${priceDayId}/delete`);
  },

  /**
   * @param seasonDepartureId
   * @param direction
   * @returns {AxiosPromise}
   */
  getDepartureBlockDays(seasonDepartureId, direction) {
    return conduit.get(`seasons/prices/${seasonDepartureId}/direction/${direction}/block`);
  },

  addDepartureBlockDay(seasonDepartureId, direction, body) {
    return conduit.post(`seasons/prices/${seasonDepartureId}/direction/${direction}/block`, body);
  },

  deleteDepartureBlockDay(seasonDepartureId, direction, body) {
    return conduit.delete(`seasons/prices/${seasonDepartureId}/direction/${direction}/block`, body);
  },
};



// WEBPACK FOOTER //
// ./src/services/transportation-service.js